import React from 'react';

const downloads = [
  {
    id: 1,
    name: 'XAUUSD Smart EA v1.2',
    fileType: '.mq5',
    date: 'May 15, 2025',
    link: '#',
  },
  {
    id: 2,
    name: 'Signal Strategy PDF Guide',
    fileType: '.pdf',
    date: 'May 13, 2025',
    link: '#',
  },
  {
    id: 3,
    name: 'Advanced RSI Divergence Code',
    fileType: '.zip',
    date: 'May 10, 2025',
    link: '#',
  },
];

export default function DownloadsCenterBox() {
  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">📥 Downloads Center</h3>
      <ul className="space-y-3 text-sm text-gray-700">
        {downloads.map((file) => (
          <li
            key={file.id}
            className="p-3 bg-gray-50 rounded border-l-4 border-indigo-500 shadow-sm flex justify-between items-center"
          >
            <div>
              <div className="font-semibold">{file.name}</div>
              <div className="text-xs text-white">
                {file.fileType} • Downloaded on {file.date}
              </div>
            </div>
            <a
              href={file.link}
              className="text-xs text-blue-600 hover:underline font-medium"
              download
            >
              Download
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
